import { render, staticRenderFns } from "./DossiersAFinaliser.vue?vue&type=template&id=0a2bb1bf&"
import script from "./DossiersAFinaliser.vue?vue&type=script&lang=js&"
export * from "./DossiersAFinaliser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports